var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.row.status ? _vm.$companyConfiguration.cardStatuses.getStatusShowName(_vm.row.status) : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }